export default {
  // Navigation
  nav: {
    spreadsheet: 'Spreadsheet',
    categories: 'Categories',
    products: 'Products',
    guides: 'Guides',
    reviews: 'Reviews',
    shipping: 'Shipping',
    safety: 'Safety',
    comparisons: 'Comparisons',
    faq: 'FAQ',
    mainSite: 'Main Website',
  },

  // Language switcher
  languages: {
    en: 'English',
    fr: 'Français',
    da: 'Dansk',
    de: 'Deutsch',
  },

  // Hero section
  hero: {
    h1: 'AllChinaBuy Spreadsheet — Find Products, Sellers & Buying Resources',
    subtitle: 'Explore the AllChinaBuy spreadsheet, product lists, seller resources, QC guides, shipping information and practical buying tips — all organized in one easy-to-use resource hub.',
    ctaPrimary: 'Explore AllChinaBuy Spreadsheet',
    ctaSecondary: 'Visit Main Website',
    searchPlaceholder: 'Search AllChinaBuy spreadsheet, products, sellers or guides…',
    trust: 'Independent Resource • Updated Regularly • Beginner Friendly',
  },

  // Categories section
  categories: {
    title: 'Popular Categories',
    subtitle: 'Browse products by category and discover the best items available through AllChinaBuy',
    viewAll: 'View All Categories',
  },

  // Category dropdown
  dropdown: {
    label: 'Select a Category',
    placeholder: 'Choose a product category...',
    goButton: 'Go to Category',
  },

  // Main CTAs
  ctas: {
    exploreTitle: 'AllChinaBuy Spreadsheet',
    exploreDesc: 'Access the complete product and seller spreadsheet with curated links and updated information.',
    exploreButton: 'AllChinaBuy Spreadsheet',
    buyTitle: 'Buy It Now',
    buyDesc: 'Skip the research and go directly to the main website to start shopping right away.',
    buyButton: 'Buy It Now',
  },

  // Spreadsheet section
  spreadsheet: {
    title: 'Spreadsheet Explorer',
    subtitle: 'Navigate the AllChinaBuy spreadsheet with ease. Find products, sellers, and resources organized for quick access.',
    feature1: 'Curated Product Links',
    feature2: 'Verified Seller Directory',
    feature3: 'Updated Regularly',
    feature4: 'Beginner Friendly',
  },

  // Featured products section
  featured: {
    title: 'Featured Products',
    subtitle: 'Discover trending items from the AllChinaBuy spreadsheet community',
  },

  // Guides section
  guides: {
    title: 'Latest Guides',
    subtitle: 'Step-by-step guides to help you research, buy, and ship products safely',
    readMore: 'Read Guide',
    guide1Title: 'AllChinaBuy Spreadsheet Complete Guide',
    guide1Desc: 'Learn everything about using the AllChinaBuy spreadsheet effectively for product research.',
    guide2Title: 'How to Find Reliable Sellers',
    guide2Desc: 'Essential tips for evaluating seller reputation and avoiding common pitfalls.',
    guide3Title: 'Shipping & Warehouse Guide',
    guide3Desc: 'Compare shipping methods, calculate costs, and choose the best delivery option.',
    guide4Title: 'AllChinaBuy Review 2026',
    guide4Desc: 'Honest and up-to-date review of the AllChinaBuy platform, features, and user experience.',
  },

  // Trust badges
  trust: {
    title: 'Why Trust This Resource?',
    independent: 'Independent Platform',
    independentDesc: 'We are not affiliated with AllChinaBuy. Our goal is to provide honest, helpful information.',
    updated: 'Regularly Updated',
    updatedDesc: 'Content is reviewed and updated to reflect the latest platform changes and shipping rates.',
    beginner: 'Beginner Friendly',
    beginnerDesc: 'Clear explanations and step-by-step guides make it easy for newcomers to get started.',
  },

  // Search cards
  searchCards: {
    title: 'Popular Searches',
    spreadsheet: 'AllChinaBuy Spreadsheet',
    review: 'AllChinaBuy Review',
    shipping: 'AllChinaBuy Shipping Cost',
    coupon: 'AllChinaBuy Coupon',
    discount: 'AllChinaBuy Discount Code',
    warehouse: 'AllChinaBuy Warehouse',
    legit: 'AllChinaBuy Legit',
    qc: 'AllChinaBuy QC',
  },

  // Final CTA
  finalCta: {
    title: 'Ready to Explore More Products?',
    subtitle: 'Use our guides to research first, then continue to the main website to explore more products.',
    button: 'Continue to Main Website',
  },

  // Footer
  footer: {
    about: 'About',
    contact: 'Contact',
    editorial: 'Editorial Policy',
    privacy: 'Privacy',
    terms: 'Terms',
    disclaimer: 'Disclaimer',
    affiliate: 'Affiliate Disclosure',
    description: 'An independent resource hub for AllChinaBuy spreadsheet users. We help buyers research products, sellers, and shipping options before making purchases.',
    copyright: 'All rights reserved.',
    notAffiliated: 'This website is an independent informational resource and is not the official AllChinaBuy website.',
  },

  // Breadcrumb
  breadcrumb: {
    home: 'Home',
  },

  // Article page
  article: {
    toc: 'Table of Contents',
    updated: 'Updated',
    author: 'Author',
    readTime: 'min read',
    related: 'Related Articles',
    backToHome: 'Back to Home',
  },

  // FAQ
  faq: {
    title: 'Frequently Asked Questions',
    q1: 'What is AllChinaBuy spreadsheet?',
    a1: 'The AllChinaBuy spreadsheet is a curated collection of product links, seller information, and buying resources organized to help shoppers find items efficiently through the AllChinaBuy platform.',
    q2: 'Is AllChinaBuy legit?',
    a2: 'AllChinaBuy is a legitimate shopping agent platform. However, as with any online purchase, buyers should research sellers, check QC photos, and understand shipping costs before ordering.',
    q3: 'How do I use the AllChinaBuy spreadsheet?',
    a3: 'Browse the spreadsheet by category, click on product links to view details, compare sellers, and use the provided links to navigate to the AllChinaBuy platform for purchasing.',
    q4: 'What shipping methods does AllChinaBuy offer?',
    a4: 'AllChinaBuy offers multiple shipping options including international express, standard shipping, and warehouse consolidation. Costs vary by destination and package weight.',
  },

  // Comparison
  comparison: {
    title: 'How AllChinaBuy Compares',
    feature: 'Feature',
    productDiscovery: 'Product Discovery',
    spreadsheetResources: 'Spreadsheet Resources',
    qc: 'QC Photos',
    warehouse: 'Warehouse Storage',
    shipping: 'Shipping Options',
    payment: 'Payment Methods',
    support: 'Customer Support',
  },

  // Safety
  safety: {
    title: 'Safety Center',
    subtitle: 'Essential information to help you shop safely and avoid common risks',
    payment: 'Payment Safety',
    paymentDesc: 'Use secure payment methods and never share login credentials with sellers directly.',
    verification: 'Seller Verification',
    verificationDesc: 'Check seller ratings, review history, and community feedback before placing orders.',
    qc: 'QC Safety',
    qcDesc: 'Always request and review QC photos before approving shipments from the warehouse.',
    scams: 'Common Scams',
    scamsDesc: 'Learn to identify suspicious links, fake sellers, and common phishing attempts.',
  },
};